import { ArrowUpRight } from 'lucide-react'
import { Link } from 'react-router-dom'
import type { Collection } from '../types'
import { number, short, sol } from '../utils'

function royalty(value?: number | null) {
  return value == null ? '—' : `${(Number(value) / 100).toFixed(2)}%`
}

export function CollectionCards({ rows }: { rows: Collection[] }) {
  return <div className="collection-card-grid">
    {rows.map((row) => (
      <Link
        className="collection-market-card"
        to={`/collection/${row.collection_address}`}
        key={row.collection_address}
      >
        <div className="collection-market-media">
          {row.image_url
            ? <img src={row.image_url} alt={row.name || 'Collection'} loading="lazy" decoding="async"/>
            : <span>{(row.symbol || row.name || 'R').slice(0, 1)}</span>}
          <div className="collection-market-open">
            <span>Open collection</span>
            <ArrowUpRight size={15}/>
          </div>
        </div>

        <div className="collection-market-body">
          <div className="collection-market-title">
            <div>
              <span>{row.symbol || 'COLLECTION'}</span>
              <h3>{row.name || short(row.collection_address)}</h3>
            </div>
            {Number(row.listed_count || 0) > 0 && (
              <span className="collection-live-chip">
                {number(row.listed_count)} listed
              </span>
            )}
          </div>

          <p>
            {row.description ||
              `${number(row.asset_count)} indexed NFT${Number(row.asset_count || 0) === 1 ? '' : 's'} on Solana`}
          </p>

          <div className="collection-market-stats">
            <div>
              <span>Floor</span>
              <b>{sol(row.floor_lamports)}</b>
            </div>
            <div>
              <span>Volume</span>
              <b>{sol(row.volume_lamports)}</b>
            </div>
            <div>
              <span>Listed</span>
              <b>{number(row.listed_count)}</b>
            </div>
            <div>
              <span>Supply</span>
              <b>{number(row.asset_count)}</b>
            </div>
          </div>

          <div className="collection-market-foot">
            <span>Royalty</span>
            <b>{royalty(row.royalty_basis_points)}</b>
          </div>
        </div>
      </Link>
    ))}
  </div>
}

